window._                                                = require('lodash');
window.axios                                            = require('axios');
window.axios.defaults.baseURL                           = 'http://www.ewsc.com/api/';
window.axios.defaults.headers.common['Content-Type']    = 'application/x-www-form-urlencoded;charset=UTF-8';

/* instance */
const instance = window.axios.create();
instance.interceptors.request.use(function(request) {
    let baseToken = document.querySelector('meta[name="token"]').getAttribute('content');
    let userToken = localStorage.getItem('token');
    if (userToken) {
        request.headers.Authorization = 'Bearer ' + userToken;
    } else {
        request.headers.Authorization = 'Bearer ' + baseToken;
    }

    return request;
}, function(error)
{
    error.response.data = {
        resp_msg: {
            code: 500,
            message: 'Server Error'
        }
    };

    return error.response;
});

instance.interceptors.response.use(function(response) {
    return response.data;
}, function(error)
{
    error.response.data = {
        resp_msg: {
            code: 500,
            message: 'Server Error'
        }
    };

    return error.response;
});

/* api */
let api = {};
api.request = function(method, data)
{
    return instance.post(method, data);
};

api.getJson = function(jsonName)
{
    return window.axios.get(`${jsonName}.json`, { baseURL: './json/' })
        .then((response) => { return response.data; })
        .catch((error) =>
        {
            throw error.response.data;
        });
}

export default api
